document.addEventListener("DOMContentLoaded", function () {
  function setCSSVariables() {
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );

    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        document.querySelector("header").getBoundingClientRect().bottom
      )}px`
    );
  }

  setCSSVariables();

  class CLMenuDrawer extends HTMLElement {
    constructor() {
      super();

      this.openMenuButton = document.querySelector(
        '[data-action="open-drawer"]'
      );
      this.closeMenuButtons = document.querySelectorAll(
        '[data-action="close-drawer"]'
      );

      this.openMenuButton.addEventListener("click", this.openMenu.bind(this));
      this.closeMenuButtons.forEach((button) => {
        button.addEventListener("click", this.closeMenu.bind(this));
      });

      this.initSubmenus();
    }

    openMenu() {
      this.classList.add("active");
      document.body.classList.add("overflow-hidden-tablet");
    }

    closeMenu() {
      this.classList.remove("active");
      document.body.classList.remove("overflow-hidden-tablet");
      this.resetMenuState();
    }

    initSubmenus() {
      this.querySelectorAll("[data-toggle='submenu']").forEach((button) => {
        button.addEventListener("click", (event) => {
          event.stopPropagation();

          let submenu = button.nextElementSibling;
          let isOpen = submenu.classList.contains("open");
          let path = button.querySelector(".icon-plus svg path");

          if (!isOpen) {
            submenu.style.maxHeight = submenu.scrollHeight + "px";
            submenu.classList.add("open");
            path.setAttribute("d", "M5 11H17V12H5Z");
          } else {
            submenu.style.maxHeight = "0px";
            submenu.classList.remove("open");
            path.setAttribute(
              "d",
              "M10.3123 11.6875H5.0415V10.3125H10.3123V5.04163H11.6873V10.3125H16.9582V11.6875H11.6873V16.9583H10.3123V11.6875Z"
            );
          }
        });
      });
    }

    resetMenuState() {
      this.querySelectorAll("[data-toggle='submenu']").forEach((button) => {
        let submenu = button.nextElementSibling;
        submenu.style.maxHeight = "0px";
        submenu.classList.remove("open");

        let path = button.querySelector(".icon-plus svg path");
        path.setAttribute(
          "d",
          "M10.3123 11.6875H5.0415V10.3125H10.3123V5.04163H11.6873V10.3125H16.9582V11.6875H11.6873V16.9583H10.3123V11.6875Z"
        );
      });
    }
  }

  customElements.define("cl-header-drawer", CLMenuDrawer);
});
